import { getUserAction } from '@/features/auth/actions/get-user.action'
import {
  UserMessagesModel,
  UserModel,
} from '@/features/auth/types/models/user.model'
import { useTransition } from 'react'
import { create } from 'zustand'
import { AccountType } from '../../types/enums/account-type.enum'

type AuthState = {
  user: UserModel | null
  status: 'authenticated' | 'unauthenticated' | 'pending'
  isAuthenticated: boolean
  accountType: AccountType | null
  messages: UserMessagesModel[]
  setUser: (user: UserModel, messages?: UserMessagesModel[]) => void
  clearUser: () => void
}

const authStore = create<AuthState>(set => ({
  user: null,
  accountType: null,
  isAuthenticated: false,
  status: 'pending',
  messages: [],
  setUser: (user, messages) =>
    set({
      user,
      isAuthenticated: true,
      accountType: user.accountType,
      messages,
      status: 'authenticated',
    }),
  clearUser: () =>
    set({
      user: null,
      isAuthenticated: false,
      accountType: null,
      status: 'unauthenticated',
    }),
}))

export const useAuth = () => {
  const store = authStore()
  const [, startTransition] = useTransition()

  const revalidateUser = () => {
    startTransition(() => {
      getUserAction()
    })
  }

  return {
    ...store,
    revalidateUser,
  }
}
